import { observer } from "mobx-react-lite";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import BriaDropDown from "../../../../../../../components/common/BriaDropDown/BriaDropDown";
import BriaTooltip from "../../../../../../../components/common/BriaTooltip/BriaTooltip";
import { useAppStore } from "../../../../../../../hooks/useStores";
import { fabricCustomTextTypes } from "../../../../../../campaign-store";
import { useActiveObject } from "../../../../../../hooks/useActiveObject";
import { useEditor } from "../../../../../../hooks/useEditor";
import { IStaticText } from "../../../../../../types";
import styles from "./TextBoxTypesDropDown.module.scss";
const TextBoxTypesDropDown = () => {
	const { t } = useTranslation("translation", { keyPrefix: "editor.controllers.textControllers" });
	const activeObject = useActiveObject() as Required<IStaticText>;
	const editor = useEditor();
	const { campaignStore } = useAppStore();
	const [textType, setTextType] = useState<string>(
		activeObject?.fixedSize ? fabricCustomTextTypes.FIXED : fabricCustomTextTypes.AUTOEXPAND,
	);

	const makeTextFixedSize = useCallback(
		(value: boolean) => {
			editor?.objects.update(
				{
					fixedSize: value,
				},
				undefined,
				!campaignStore.isEditingAllAds,
			);
			setTextType(value ? fabricCustomTextTypes.FIXED : fabricCustomTextTypes.AUTOEXPAND);
			// When pressing "fix" - Width + height + max font should be reset per the current state
			activeObject.fixedWidthValue = activeObject.width;
			activeObject.fixedHeightValue = activeObject.height;
			activeObject.maximumFontSize = activeObject.fontSize;
			if (!value) {
				activeObject?.setControlsVisibility({
					mt: true,
					mb: true,
					ml: true,
					mr: true,
					bl: true,
					br: true,
					tl: true,
					tr: true,
					mtr: true,
				});
			} else {
				activeObject?.setControlsVisibility({
					mt: false,
					mb: false,
					ml: false,
					mr: false,
					bl: false,
					br: false,
					tl: false,
					tr: false,
					mtr: false,
				});
			}
			// TODO:It's not needed for now, may be we need to add it in future
			// EditAllAds(LayerType.STATIC_TEXT, activeObject.textType, FeatureType.FIXEDTEXTBOX, value);
		},
		[editor],
	);
	return (
		<BriaTooltip title={t("textElementType")}>
			<BriaDropDown
				width="146px"
				height={"20px"}
				labelFontSize={"12px"}
				labelFontWeight={500}
				value={textType}
				className={styles.textElementTypeDropDown}
				onChange={(e) => {
					makeTextFixedSize(e.target.value === fabricCustomTextTypes.FIXED);
				}}
				items={[
					{
						key: t("autoExpand"),
						value: fabricCustomTextTypes.AUTOEXPAND,
						tooltip: t("autoExpandTooltip"),
					},
					{
						key: t("fixed"),
						value: fabricCustomTextTypes.FIXED,
						tooltip: t("fixedTooltip"),
					},
				]}
			/>
		</BriaTooltip>
	);
};

const ObservedComponent = observer(TextBoxTypesDropDown);
export default ObservedComponent;
